import pusherChannels from "./pusher_channels";
const Tabs = (function() {
  let localStorageTabs = [];
  const getTabsStorageKey = () => `tabs_${location.host}_${CodeEditor.Main.themeId()}`;
  function Tabs() {
    this.init();
  }

  function TabGUID() {
    return "tab-" + CodeEditor.GUID();
  }
  Tabs.config = function(title, type, componentState, isClosable) {
    this.name = title || "unnamed";
    this.type = type || "component";
    this.id = TabGUID();
    this.isClosable = isClosable || true;
  };

  Tabs.add = function(title, path, fileType, key, node) {
    let tabId;
    let config;
    let activeTab = Tabs.getActiveTab();
    tabId = TabGUID();
    config = {
      type: "component",
      id: path || tabId,
      key,
      title,
      fileType: fileType || "snippet",
      componentName: "editor component",
      tooltip: path || tabId,
      node,
      componentState: { id: path || tabId }
    };
    if (Tabs.getTab(activeTab.config.id) && Tabs.getActiveTab().config.componentName === "editor component") {
      Tabs.getActiveTab().parent.addChild(Object.assign({}, config));
      Tabs.storeTab(key);
      return config;
    }
    let stack = Panes.root.getItemsByType("stack")[1];
    stack.addChild(Object.assign({}, config));
    Tabs.storeTab(key);
    editor = CodeEditor.getEditorById(stack.editor);
    // return newTab;
    return config;
  };
  Tabs.addGenericTab = function(title, key) {
    let tabId;
    let config;
    let activeTab = Tabs.getActiveTab();
    tabId = TabGUID();
    config = {
      type: "component",
      id: key || tabId,
      key: key || tabId,
      title: title || "untitled",
      componentName: "generic component",
      tooltip: title || "untitled",
      reorderEnabled: false
    };
    if (Tabs.getTab(activeTab.config.id)) {
      Panes.root.getItemsById("utilStack")[0].addChild(Object.assign({}, config));
      return Tabs.getTab(config.id);
    } else {
      let stack = Panes.root.getItemsById("contentStack")[0];
      editor = CodeEditor.getEditorById(stack.editor);
      return stack.addChild(Object.assign({}, config));
    }
  };

  Tabs.addImageView = function(title, key, path) {
    let tabId;
    let config;
    let activeTab = Tabs.getActiveTab();
    tabId = TabGUID();
    config = {
      type: "component",
      id: path || tabId,
      key: key || tabId,
      title: title || "untitled",
      componentName: "image view",
      tooltip: title || "untitled",
      reorderEnabled: false
    };
    let stack = Panes.root.getItemsById("contentStack")[0];
    if (stack) {
      return stack.addChild(Object.assign({}, config));
    } else if (Tabs.getTab(activeTab.config.id)) {
      Tabs.getActiveTab().parent.addChild(Object.assign({}, config));
      return Tabs.getTab(config.id);
    }
    // return newTab;
    return config;
  };
  Tabs.getTab = id => Panes.root.getItemsById(String(id))[0];
  Tabs.getHeader = () => Tabs.getActiveTab().parent.header;
  Tabs.getActiveTabHeader = () => Tabs.getActiveTab().parent.header.tabsContainer.find(".lm_active");
  Tabs.getActiveTab = () => Panes.root.ActiveNode;
  Tabs.setActiveById = id => Tabs.getTab(id).parent.setActiveContentItem(Tabs.getTab(id));
  Tabs.getTabByKey = key =>
    Panes.root.getItemsByType("component").find(tab => tab.config.key && tab.config.key === key);
  Tabs.getDragoverTab = () =>
    Panes.root.getItemsByFilter(item => item.type === "stack" && item.element.find(".dnd-dragover").length > 0);
  Tabs.storeTab = key => {
    localStorageTabs.push(key);
    localStorage.setItem(getTabsStorageKey(), JSON.stringify(localStorageTabs));
  };
  Tabs.removeTab = key => {
    localStorageTabs = localStorageTabs.filter(tabKey => tabKey !== key);
    localStorage.setItem(getTabsStorageKey(), JSON.stringify(localStorageTabs));
  };

  Tabs.recentTabs = async () => {
    let storageTabs = localStorage.getItem(getTabsStorageKey());
    if (!storageTabs || storageTabs === "[]" || !Array.isArray(JSON.parse(storageTabs))) {
      return true;
    }
    storageTabs = JSON.parse(storageTabs);
    const tabs = Array.from(storageTabs, key => tree.getNodeByKey(key)).filter(node => node);
    let openRecentTabs = true;
    if (tabs.length > 4) {
      openRecentTabs = confirm(`you have ${tabs.length} recent tabs, do you want to open all of them?`);
    }
    if (openRecentTabs) {
      $(".editor-wrapper").addClass("loading_recent_tabs");
      const loadRecentTab = async function*() {
        let index = 0;
        while (tabs[index]) {
          await CodeEditor.Tree.openFile(null, tabs[index]);
          yield false;
          index++;
        }
        yield true;
      };

      for await (const done of loadRecentTab()) {
        if (done) {
          $(".editor-wrapper").removeClass("loading_recent_tabs");
        }
      }
    }
  };
  // Tabs.setActiveTab = tab => Tabs.getHeader().

  Tabs.close = (id, silent) => {
    silent = silent || false;
    const node = typeof id === "object" ? id.contentItem : Tabs.getTab(id);
    const $node = typeof id === "object" ? id.element : Tabs.getTab(id).container.tab.element;
    const key = node.config.key;
    if ($node.find(".file_save")) {
      const savedNode = $node.find(".file_save.loaded,.file_save.save_success").length ? true : false;
      if (node.config.id === "welcome" || silent || savedNode) {
        pusherChannels.triggerEvent({
          eventName: "file-offline",
          data: { file: { ...node.config, node: null } }
        });
        node.remove();
        Tabs.removeTab(node.config.key);
        typeof editor !== "undefined" && CodeEditor.Main.refreshContent();
        if (Panes.getLastStack() != null) {
          Panes.root.ActiveNode = Panes.getLastStack();
          Panes.getLastStack().element[0].click();
          typeof editor !== "undefined" && editor.focus();
        }
        let activeTab = Tabs.getActiveTab();
        if (activeTab.config.componentName === "editor component") {
          let key = activeTab.config.key;
          if (key !== null && key !== "-1") {
            CodeEditor.Tree.selectNode(key);
          }
        }
      } else {
        let modal = Tabs.modal();
        modal.open();
        modal.setContent(
          "<p>Your changes aren't saved, are you sure you want to exit ?</p><code>" + $node[0].textContent + "</code>"
        );
        modal.addFooterBtn("Accept", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {
          node.remove();
          Tabs.removeTab(key);
          typeof editor !== "undefined" && CodeEditor.Main.refreshContent();
          if (Panes.getLastStack() != null) {
            Panes.root.ActiveNode = Panes.getLastStack();
            Panes.getLastStack().element[0].click();
            typeof editor !== "undefined" && editor.focus();
          }
          let activeTab = Tabs.getActiveTab();
          if (activeTab.config.componentName === "editor component") {
            let key = activeTab.config.key;
            if (key !== null && key !== "-1") {
              CodeEditor.Tree.selectNode(Tabs.getActiveTab().config.key);
            }
          }
          Tabs.removeTab(node.config.key);
          pusherChannels.triggerEvent({
            eventName: "file-closed",
            data: {
              file: {
                ...node.config,
                node: null
              }
            }
          });
          modal.destroy();
        });

        modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
          modal.destroy();
        });
      }
    }
    return typeof node === "undefined";
  };

  Tabs.modal = () => {
    let $tingle = require("tingle.js");
    let modal = new $tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      closeLabel: "Close",
      cssClass: ["mw_ixcanul"],
      onOpen: () => {
        console.log("modal open");
      },
      onClose: () => {
        console.log("modal closed");
      },
      beforeClose: () => {
        return false; // nothing happens
      }
    });
    return modal;
  };

  return Tabs;
})();

export default Tabs;
